<div class="container mt-4 pb-4">
   <div class="pattern_bg">
      <img src="../../../assets/images/pattern-bg.svg" />
   </div>
   <header
      class="px-xxl-0 align-items-centerX justify-content-between gap-2 section-header"
   >
      <div class="d-flex justify-content-start align-items-center gap-3">
         <h1 class="main-heading mb-0">Earnings Calendar</h1>
         <!-- <button *ngIf="selectedCountry" type="button"
        class="btn border d-flex align-items-center shadow-none gap-1 gap-lg-2 rounded-pill country-filter-btn"
        (click)="openCountriesPopup()">
        <img [src]="selectedCountry ? '/assets/flags/1x1/' + selectedCountry.toLowerCase() + '.svg' : ''" alt=""
          class="bg-light border rounded-circle" width="20px" height="20px" />
        <span class="fw-500">{{ selectedCountry }}</span>
        <svg height="10px" width="10px" class="chevron-svg flex-shrink-0" viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor"
            d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
        </svg>
      </button> -->
         <div class="country-selector" [class.open]="showDropdown">
            <div class="selected-option" (click)="toggleDropdown()">
               <img
                  [src]="
                     '/assets/flags/1x1/' +
                     selectedCountry.toLowerCase() +
                     '.svg'
                  "
                  alt=""
                  class="country-flag"
                  width="20"
                  height="20"
               />
               <span class="country-name">{{
                  getCountryName(selectedCountry)
               }}</span>
               <svg
                  class="dropdown-icon"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <path
                     d="M1 1L5 5L9 1"
                     stroke="currentColor"
                     stroke-width="1.5"
                     stroke-linecap="round"
                  />
               </svg>
            </div>

            <div class="dropdown-options" *ngIf="showDropdown">
               <div class="option" (click)="selectCountry('US')">
                  <img
                     src="/assets/flags/1x1/us.svg"
                     alt=""
                     class="country-flag"
                     width="20"
                     height="20"
                  />
                  <span>USA</span>
               </div>
               <div class="option" (click)="selectCountry('IN')">
                  <img
                     src="/assets/flags/1x1/in.svg"
                     alt=""
                     class="country-flag"
                     width="20"
                     height="20"
                  />
                  <span>India</span>
               </div>
            </div>
         </div>
      </div>
      <p class="header__description">
         View upcoming earnings reports to track company performance and stay
         informed.
      </p>
   </header>

   <div class="tab__with_search_row">
      <ul class="calendar_tab mt-4">
         <li
            *ngFor="let tab of tabs"
            [ngClass]="{ active: tab === selectedTab }"
            (click)="selectTab(tab)"
         >
            {{ tab }}
         </li>
      </ul>

      <div style="position: relative; max-width: 450px; width: 100%">
         <div class="calendar__search__box">
            <div class="search-container">
               <input
                  #searchInput
                  type="text"
                  [(ngModel)]="searchQuery"
                  (input)="onSearchInput(searchInput.value)"
                  class="animated-input"
               />

               <div class="placeholder-container" *ngIf="!searchQuery">
                  <div
                     class="placeholder-text"
                     [class.active]="currentPlaceholder === 'symbol'"
                     [class.exiting]="placeholderState === 'exiting-symbol'"
                  >
                     Find Earnings by Symbol
                  </div>
                  <div
                     class="placeholder-text"
                     [class.active]="currentPlaceholder === 'company'"
                     [class.exiting]="placeholderState === 'exiting-company'"
                  >
                     Find Earnings by Company Name
                  </div>
               </div>
            </div>

            <button class="search-button" *ngIf="searchQuery.length === 0">
               <img src="../../../assets/icons/iconSearch.svg" />
            </button>
            <button
               *ngIf="searchQuery.length > 0"
               class="clear-button"
               (click)="clearSearch()"
               type="button"
            >
               <img src="../../../assets/icons/iconClose.svg" alt="Clear" />
            </button>
         </div>

         <ul
            #searchDropdown
            class="search-suggestions"
            *ngIf="searchQuery && showSearchDropdown"
         >
            <!-- Show search results if available -->
            <li
               *ngFor="let r of searchResults"
               (click)="onSelectSearchResult(r)"
               class="search-result-item"
            >
               <div class="search-result-template">
                  <h6 class="mb-0 line-clamp-1 stock-name">
                     {{ r.company_symbol }}
                  </h6>
                  <p class="mb-0 line-clamp-1 company-name">{{ r.name }}</p>
                  <div class="d-flex align-items-center gap-1 stock-exchange">
                     <!-- Country flag using exchange_code (like 'US') -->
                     <img
                        *ngIf="r.exchange_code"
                        [src]="
                           '/assets/flags/1x1/' +
                           r.exchange_code.toLowerCase() +
                           '.svg'
                        "
                        placeholder="/assets/images/dashboard/stock-lowres.png"
                        [alt]="r.exchange_code"
                        class="img-fluid country-flag rounded-circle"
                     />

                     <span>{{ r.exchange_symbol }}</span>
                  </div>
               </div>
            </li>

            <!-- No results message -->
            <li
               *ngIf="searchResults.length === 0"
               class="search-result-item disabled"
               style="border-bottom: none"
            >
               <div
                  class="search-result-template text-muted text-center"
                  style="justify-content: center"
               >
                  No Symbol or Company Name found
               </div>
            </li>
         </ul>
      </div>
   </div>

   <div class="tab-content mt-5 mb-3">
      <!-- For Yesterday/Today/Next Week -->
      <div
         *ngIf="selectedTab !== 'Next Month'"
         class="calendar-scroll-container"
      >
         <ul class="calendar_row_list" @listAnimation>
            <li
               *ngFor="let day of days; let i = index"
               [ngClass]="{
                  active: i === selectedIndex,
                  'non-clickable':
                     selectedTab === 'Today' || selectedTab === 'Yesterday'
               }"
               (click)="
                  selectedTab !== 'Today' && selectedTab !== 'Yesterday'
                     ? select(i)
                     : null
               "
            >
               <h6>{{ day.day }}</h6>
               <h5>{{ day.date }}</h5>
               <p>
                  {{ dateCounts[day.apiDate] ?? "--" }}
                  <span>Releases</span>
               </p>
            </li>
         </ul>
      </div>

      <!-- For Next Month -->
      <div *ngIf="selectedTab === 'Next Month'" class="calendar_wrapper">
         <div
            class="selected-date-earnings"
            *ngIf="selectedDate && dataCount !== undefined"
         >
            <strong>{{ dataCount }}</strong> earnings for selected date
         </div>
         <button
            *ngIf="!isPrevDisabled"
            class="btn_arrow btn_arrow_left"
            (click)="prevPage()"
         >
            <i class="fa fa-angle-left"></i>
         </button>

         <div class="calendar-row-container" #calendarRowListWrapper>
            <ul class="calendar_row_list scrollable-list">
               <li
                  *ngFor="let day of visibleMonthDays; let i = index"
                  [ngClass]="{ active: i === selectedIndex }"
                  (click)="select(i)"
               >
                  <h6>{{ day.day }}</h6>
                  <h5>{{ day.date }}</h5>
                  <p>
                     {{ dateCounts[day.apiDate] ?? "--" }}
                     <span>Earnings</span>
                  </p>
               </li>
            </ul>
         </div>

         <button
            *ngIf="!isNextDisabled"
            class="btn_arrow btn_arrow_right"
            (click)="nextPage()"
         >
            <i class="fa fa-angle-right"></i>
         </button>
      </div>
   </div>

   <div class="min-width-zero">
      <app-dynamic-table
         [columns]="tableColumns"
         [data]="data"
         [page]="page"
         [dataCount]="dataCount"
         [isDataLoading]="stocksLoading"
         [showResetButton]="true"
         [isSortingEnabled]="true"
         [sortColumn]="usdMarketCap"
         [sortOrder]="desc"
         [type]="dataType"
         [hideFiltersCount]="true"
      >
      </app-dynamic-table>
   </div>
</div>
